import { datadogRum } from '@datadog/browser-rum';
import config from '@/config';

const DDRum = {
  init() {
    datadogRum.init({
      applicationId: config.get().datadogRumApplicationId,
      clientToken: config.get().datadogRumClientToken,
      site: 'datadoghq.com',
      service: 'elsa',
      env: config.get().datadogRumEnvironment,
      sampleRate: 100,
      replaySampleRate: 0,
    });
  },
};

export default DDRum;
